import { BoxButton, Description } from '@repo/ui';
import { ReactNode } from 'react';

import ErrorContactUsButtonContent from '@/components/tax-refund/common/error/ErrorContactUsButtonContent';

export interface ErrorBaseViewController {
  graphic?: ReactNode;
  title: string;
  description?: ReactNode;
  primaryButtonText?: string;
  onPrimaryButtonClick?: () => void;
  disabledPrimaryButton?: boolean;
  primaryButtonVariant?: 'filled-primary' | 'filled-error' | 'tonal-primary' | 'tonal-secondary' | 'tonal-error';
  secondaryButtonText?: string;
  onSecondaryButtonClick?: () => void;
  footerClickEvent?: string;
}

interface Props {
  viewController: ErrorBaseViewController;
}

const ErrorBaseView = ({ viewController }: Props) => {
  const {
    graphic,
    title,
    description,
    primaryButtonText,
    onPrimaryButtonClick,
    disabledPrimaryButton = false,
    primaryButtonVariant = 'filled-primary',
    secondaryButtonText,
    onSecondaryButtonClick,
    footerClickEvent
  } = viewController;

  return (
    <section className="px-8 py-spacious-medium">
      <Description
        className="p-6"
        title={title}
        description={description}
        graphic={graphic}
        button={
          primaryButtonText && onPrimaryButtonClick ? (
            <BoxButton variant={primaryButtonVariant} size="medium" disabled={disabledPrimaryButton} onClick={onPrimaryButtonClick}>
              {primaryButtonText}
            </BoxButton>
          ) : undefined
        }
      />

      {secondaryButtonText && (
        <div className="mt-normal-medium">
          <BoxButton variant="tonal-secondary" size="medium" onClick={onSecondaryButtonClick}>
            {secondaryButtonText}
          </BoxButton>
        </div>
      )}

      {footerClickEvent && <ErrorContactUsButtonContent clickEvent={footerClickEvent} />}
    </section>
  );
};

export default ErrorBaseView;
